<template>
  <main class="flex min-w-screen min-h-screen font-sans">
        <div class="flex flex-col w-full gap-[30px]">
            <Navbar />
            <Loader />
        </div>

    <Toast />
    </main>
</template>

<script setup lang="ts">

import Navbar from '@/components/Navbar/Navbar.vue';
import Loader from '@/components/Loader/Loader.vue';
</script>
